export default ({ request }) => ({

  listResearchTagApi(data) {
    return request({
      url: '/digitalCenter/researchTag/list',
      method: 'post',
      data
    })
  },
  saveResearchTagApi(data) {
    return request({
      url: '/digitalCenter/researchTag/save',
      method: 'post',
      data
    })
  },
  detailResearchTagApi(data) {
    return request({
      url: '/digitalCenter/researchTag/detail',
      method: 'post',
      data
    })
  },
  delResearchTagApi(data) {
    return request({
      url: '/digitalCenter/researchTag/del',
      method: 'post',
      data
    })
  }
})
